(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-about-us"]) return;
  try {
    
(function () {
  function initModal(scope) {
    var root = scope.querySelector('[data-au-modal]');
    if (!root || root.dataset.auBound) return;
    root.dataset.auBound = '1';

    var frame = root.querySelector('[data-au-frame]');
    var lastFocus = null;

    function open(tplId) {
      var tpl = scope.querySelector('template[data-au-tpl="' + tplId + '"]');
      if (!tpl) return;
      frame.innerHTML = '';
      frame.appendChild(tpl.content.cloneNode(true));
      root.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var closeBtn = root.querySelector('[data-au-close]');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      root.hidden = true;
      frame.innerHTML = '';
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    scope.querySelectorAll('[data-au-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        lastFocus = btn;
        open(btn.getAttribute('data-au-open'));
      });
    });

    root.querySelectorAll('[data-au-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) close();
    });
  }

  document.querySelectorAll('.au').forEach(function (el) { initModal(el); });
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('.au') : null;
    if (el) initModal(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header"] && !Shopify.designMode) return;
  try {
    
class RavelHeader extends HTMLElement {
  connectedCallback() {
    this.predictiveUrl = this.dataset.predictiveUrl;
    this.initAnnouncement();
    this.initMega();
    this.initSearch();
    this.initMobile();
    this.initAccordions();
  }

  /* ---- Announcement carousel ---- */
  initAnnouncement() {
    const bar = this.querySelector('.rv-ann');
    if (!bar) return;
    const slides = [...bar.querySelectorAll('.rv-ann__slide')];
    const dots = [...bar.querySelectorAll('.rv-ann__dot')];
    if (slides.length <= 1) {
      const ctrls = bar.querySelector('.rv-ann__controls');
      const prev = bar.querySelector('.rv-ann__prev');
      if (ctrls) ctrls.style.display = 'none';
      if (prev) prev.style.display = 'none';
      return;
    }
    let i = 0;
    const show = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
    };
    bar.querySelector('.rv-ann__prev')?.addEventListener('click', () => { show(i - 1); reset(); });
    bar.querySelector('.rv-ann__next')?.addEventListener('click', () => { show(i + 1); reset(); });
    dots.forEach((d) => d.addEventListener('click', () => { show(+d.dataset.index); reset(); }));

    let timer = null;
    const auto = bar.dataset.autoplay === 'true';
    const speed = (parseFloat(bar.dataset.speed) || 4) * 1000;
    const start = () => { if (auto) timer = setInterval(() => show(i + 1), speed); };
    const reset = () => { clearInterval(timer); start(); };
    start();
    bar.addEventListener('mouseenter', () => clearInterval(timer));
    bar.addEventListener('mouseleave', start);
  }

  /* ---- Desktop mega menu (hover-driven, matches prototype) ---- */
  initMega() {
    const wrap = this.querySelector('[data-navwrap]');
    if (!wrap) return;
    const items = [...this.querySelectorAll('[data-mega-item]')];
    const closeAll = () => items.forEach((it) => it.classList.remove('is-open'));

    items.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        if (window.matchMedia('(max-width: 989px)').matches) return;
        closeAll();
        item.classList.add('is-open');
        this.closeSearch();
      });
      // keyboard support
      item.querySelector('[data-mega-trigger]')?.addEventListener('focus', () => {
        closeAll(); item.classList.add('is-open');
      });
    });
    wrap.addEventListener('mouseleave', closeAll);
    this.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });

    // concern tabs
    this.querySelectorAll('.rv-tab').forEach((tab) => {
      const activate = () => {
        const panel = tab.closest('.rv-pro-panel__body');
        if (!panel) return;
        panel.querySelectorAll('.rv-tab').forEach((t) => t.classList.toggle('is-active', t === tab));
        panel.querySelectorAll('.rv-tabpanel').forEach((p) => p.classList.toggle('is-active', p.dataset.tabpanel === tab.dataset.tab));
      };
      tab.addEventListener('mouseenter', activate);
      tab.addEventListener('click', activate);
    });
  }

  /* ---- Predictive search (desktop + mobile) ---- */
  initSearch() {
    this.searchPanel = this.querySelector('[data-search-panel]');
    const toggle = this.querySelector('[data-search-toggle]');
    if (toggle && this.searchPanel) {
      toggle.addEventListener('click', () => {
        if (window.matchMedia('(max-width: 989px)').matches) return; // mobile handled in initMobile
        const open = this.searchPanel.hasAttribute('hidden');
        if (open) this.openSearch(); else this.closeSearch();
      });
    }
    this.querySelectorAll('[data-search-input]').forEach((input) => {
      const results = input.closest('.rv-search__inner, .rv-msearch__inner, .rv-search__main')
        ?.querySelector('[data-search-results]')
        || input.parentElement.parentElement.querySelector('[data-search-results]');
      let t = null;
      input.addEventListener('input', () => {
        clearTimeout(t);
        const q = input.value.trim();
        if (q.length < 2) { if (results) { results.hidden = true; results.innerHTML = ''; } return; }
        t = setTimeout(() => this.runSearch(q, results), 220);
      });
    });
  }

  openSearch() {
    const t = this.querySelector('[data-search-toggle]');
    this.querySelectorAll('[data-mega-item]').forEach((it) => it.classList.remove('is-open'));
    if (this.searchPanel) this.searchPanel.hidden = false;
    if (t) t.setAttribute('aria-expanded', 'true');
    this.searchPanel?.querySelector('[data-search-input]')?.focus();
  }
  closeSearch() {
    const t = this.querySelector('[data-search-toggle]');
    if (this.searchPanel) this.searchPanel.hidden = true;
    if (t) t.setAttribute('aria-expanded', 'false');
  }

  async runSearch(q, results) {
    if (!results || !this.predictiveUrl) return;
    try {
      const url = `${this.predictiveUrl}?q=${encodeURIComponent(q)}&resources[type]=product,collection,query&resources[limit]=6`;
      const res = await fetch(url);
      const data = await res.json();
      const products = (data.resources && data.resources.results && data.resources.results.products) || [];
      results.hidden = false;
      if (!products.length) {
        results.innerHTML = `<div class="rv-sres__empty">No matches for “${q}”. Press Enter to search everything.</div>`;
        return;
      }
      results.innerHTML = products.map((p) => {
        const img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
        return `<a class="rv-sres" href="${p.url}">
          <span class="rv-sres__img">${img ? `<img src="${img}" alt="" loading="lazy">` : ''}</span>
          <span class="rv-sres__body"><div class="rv-sres__name">${p.title}</div></span>
        </a>`;
      }).join('');
    } catch (e) {
      results.hidden = true;
    }
  }

  /* ---- Mobile drawer + search overlay ---- */
  initMobile() {
    this.drawer = this.querySelector('[data-drawer]');
    this.scrim = this.querySelector('[data-drawer-scrim]');
    this.msearch = this.querySelector('[data-msearch]');
    const burgers = [...this.querySelectorAll('[data-drawer-toggle]')];

    const setDrawer = (open) => {
      if (!this.drawer) return;
      this.drawer.classList.toggle('is-open', open);
      this.drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (this.scrim) { this.scrim.hidden = false; this.scrim.classList.toggle('is-open', open); }
      burgers.forEach((b) => b.setAttribute('aria-expanded', open ? 'true' : 'false'));
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) this.setMSearch(false);
    };
    this.setDrawer = setDrawer;
    burgers.forEach((b) => b.addEventListener('click', () => setDrawer(!this.drawer.classList.contains('is-open'))));
    this.scrim?.addEventListener('click', () => setDrawer(false));

    // mobile search toggle reuses the same toggle button on small screens
    const setMSearch = (open) => {
      if (!this.msearch) return;
      this.msearch.hidden = !open;
      const t = this.querySelector('[data-search-toggle]');
      if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { setDrawer(false); this.msearch.querySelector('[data-search-input]')?.focus(); }
    };
    this.setMSearch = setMSearch;
    const toggle = this.querySelector('[data-search-toggle]');
    toggle?.addEventListener('click', () => {
      if (window.matchMedia('(max-width: 989px)').matches) {
        setMSearch(this.msearch.hidden);
      }
    });
    this.addEventListener('keydown', (e) => { if (e.key === 'Escape') { setDrawer(false); setMSearch(false); } });
  }

  /* ---- Accordions (mobile menu + concerns) ---- */
  initAccordions() {
    const refreshAncestors = (el) => {
      let anc = el.parentElement ? el.parentElement.closest('[data-acc-panel]') : null;
      while (anc) {
        if (anc.style.maxHeight && anc.style.maxHeight !== '0px') {
          anc.style.maxHeight = anc.scrollHeight + 'px';
        }
        anc = anc.parentElement ? anc.parentElement.closest('[data-acc-panel]') : null;
      }
    };
    this.querySelectorAll('[data-acc-toggle]').forEach((btn) => {
      const panel = btn.nextElementSibling;
      btn.addEventListener('click', () => {
        const open = btn.getAttribute('aria-expanded') === 'true';
        // close siblings at the same level
        const parent = btn.closest('.rv-acc, .rv-mpro__body');
        if (parent && !open) {
          parent.querySelectorAll(':scope > .rv-acc__item > [data-acc-toggle], :scope > .rv-acc__item--sub > [data-acc-toggle]').forEach((sib) => {
            if (sib !== btn && sib.getAttribute('aria-expanded') === 'true') {
              sib.setAttribute('aria-expanded', 'false');
              if (sib.nextElementSibling) sib.nextElementSibling.style.maxHeight = '0px';
            }
          });
        }
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (panel) panel.style.maxHeight = open ? '0px' : panel.scrollHeight + 'px';
        refreshAncestors(btn);
      });
    });
  }
}
if (!customElements.get('ravel-header')) {
  customElements.define('ravel-header', RavelHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-pro-hair-concerns"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSection(section) {
    if (section.dataset.proHairConcernsInit === '1') return;
    section.dataset.proHairConcernsInit = '1';

    var tabs = section.querySelectorAll('[data-pro-hair-concerns-tab]');
    var panels = section.querySelectorAll('[data-pro-hair-concerns-panel]');
    var cta = section.querySelector('[data-pro-hair-concerns-cta]');

    function activate(idx) {
      Array.prototype.forEach.call(tabs, function (t) {
        var isActive = parseInt(t.getAttribute('data-target'), 10) === idx;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      Array.prototype.forEach.call(panels, function (p) {
        var isActive = parseInt(p.getAttribute('data-index'), 10) === idx;
        p.classList.toggle('is-active', isActive);
        p.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        if (isActive && cta) {
          var href = p.getAttribute('data-cta-href');
          if (href) cta.setAttribute('href', href);
        }
        if (isActive && typeof p.__updateNavState === 'function') {
          requestAnimationFrame(p.__updateNavState);
        }
      });
    }

    Array.prototype.forEach.call(tabs, function (t) {
      t.addEventListener('click', function () {
        var idx = parseInt(t.getAttribute('data-target'), 10) || 0;
        activate(idx);
      });
    });

    Array.prototype.forEach.call(panels, function (panel) {
      var list = panel.querySelector('[data-pro-hair-concerns-list]');
      var prev = panel.querySelector('[data-pro-hair-concerns-prev]');
      var next = panel.querySelector('[data-pro-hair-concerns-next]');
      if (!list) return;

      function step() {
        var first = list.querySelector('.pro-hair-concerns__item');
        if (!first) return list.clientWidth;
        var styles = window.getComputedStyle(list);
        var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return first.getBoundingClientRect().width + gap;
      }

      function updateNavState() {
        if (!prev || !next) return;
        // Skip while panel is hidden (clientWidth=0 collapses max to -1 and stuck-disables next).
        if (list.clientWidth === 0) return;
        var max = list.scrollWidth - list.clientWidth - 1;
        prev.disabled = list.scrollLeft <= 1;
        next.disabled = list.scrollLeft >= max;
      }

      if (prev) prev.addEventListener('click', function () {
        list.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        list.scrollBy({ left: step(), behavior: 'smooth' });
      });

      list.addEventListener('scroll', updateNavState, { passive: true });
      window.addEventListener('resize', updateNavState);
      panel.__updateNavState = updateNavState;
      updateNavState();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-pro-hair-concerns]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-pro-hair-concerns]');
    if (s) initSection(s);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-pro-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(section) {
    var slides = section.querySelectorAll('[data-pro-hero-slide]');
    var dots = section.querySelectorAll('[data-pro-hero-dot]');
    if (!slides.length || slides.length <= 1) return;

    var current = 0;
    var autoplay = section.getAttribute('data-autoplay') === 'true';
    var interval = parseInt(section.getAttribute('data-interval'), 10) || 5000;
    var timer = null;

    function setSlideState(idx, active) {
      slides[idx].classList.toggle('is-active', active);
      slides[idx].setAttribute('aria-hidden', active ? 'false' : 'true');
      var link = slides[idx].querySelector('.pro-hero__slide-link');
      if (link) link.setAttribute('tabindex', active ? '0' : '-1');
      if (dots[idx]) {
        dots[idx].classList.toggle('is-active', active);
        dots[idx].setAttribute('aria-selected', active ? 'true' : 'false');
      }
    }

    function go(i) {
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      if (i === current) return;
      setSlideState(current, false);
      current = i;
      setSlideState(current, true);
    }

    function next() { go(current + 1); }
    function prev() { go(current - 1); }
    function start() { stop(); if (autoplay) timer = window.setInterval(next, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    Array.prototype.forEach.call(dots, function (d) {
      d.addEventListener('click', function () {
        var i = parseInt(d.getAttribute('data-target'), 10) || 0;
        go(i);
        start();
      });
    });

    var main = section.querySelector('[data-pro-hero-main]');
    if (main) {
      var startX = 0;
      var startY = 0;
      var dragging = false;
      var moved = false;
      var THRESHOLD = 40;

      main.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        dragging = true;
        moved = false;
        startX = e.clientX;
        startY = e.clientY;
        stop();
      });

      main.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        var dy = e.clientY - startY;
        if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) {
          moved = true;
          if (e.cancelable) e.preventDefault();
        }
      }, { passive: false });

      function endDrag(e) {
        if (!dragging) return;
        dragging = false;
        var dx = (e.clientX || 0) - startX;
        if (moved && Math.abs(dx) > THRESHOLD) {
          if (dx < 0) next(); else prev();
        }
        start();
      }

      main.addEventListener('pointerup', endDrag);
      main.addEventListener('pointercancel', function () { dragging = false; start(); });
      main.addEventListener('pointerleave', function (e) { if (dragging) endDrag(e); });

      main.addEventListener('click', function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      }, true);

      main.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }

    section.addEventListener('mouseenter', stop);
    section.addEventListener('mouseleave', start);
    section.addEventListener('focusin', stop);
    section.addEventListener('focusout', start);

    start();
  }

  function initAll() {
    var sections = document.querySelectorAll('.pro-hero');
    Array.prototype.forEach.call(sections, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.pro-hero');
    if (s) init(s);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-pro-ingredients"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSection(section) {
    if (section.dataset.proIngredientsInit === '1') return;
    section.dataset.proIngredientsInit = '1';
    var dialog = section.querySelector('.pro-ingredients-dialog');
    if (!dialog) return;
    var openers = section.querySelectorAll('[data-pro-ingredients-open]');
    var closers = section.querySelectorAll('[data-pro-ingredients-close]');

    var savedScrollY = 0;

    function lockScroll() {
      savedScrollY = window.scrollY || window.pageYOffset || 0;
      document.documentElement.classList.add('pro-ingredients-dialog-open');
      document.body.classList.add('pro-ingredients-dialog-open');
      document.body.style.top = '-' + savedScrollY + 'px';
    }
    function unlockScroll() {
      document.documentElement.classList.remove('pro-ingredients-dialog-open');
      document.body.classList.remove('pro-ingredients-dialog-open');
      document.body.style.top = '';
      window.scrollTo(0, savedScrollY);
    }

    function open() {
      lockScroll();
      if (typeof dialog.showModal === 'function') {
        try { dialog.showModal(); } catch (e) {}
      } else {
        dialog.setAttribute('open', '');
      }
    }
    function close() {
      try { dialog.close(); } catch (e) { dialog.removeAttribute('open'); }
      unlockScroll();
    }

    openers.forEach(function (b) { b.addEventListener('click', open); });
    closers.forEach(function (b) { b.addEventListener('click', close); });
    /* click outside the inner panel closes */
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) close();
    });
    dialog.addEventListener('cancel', close);
    dialog.addEventListener('close', unlockScroll);
  }

  function initAll() {
    document.querySelectorAll('.pro-ingredients').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector) {
      var s = e.target.querySelector('.pro-ingredients');
      if (s) initSection(s);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-pro-journey"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(section) {
    if (section.dataset.proJourneyInit === '1') return;
    section.dataset.proJourneyInit = '1';

    var slides = section.querySelectorAll('[data-pro-journey-slide]');
    var dots = section.querySelectorAll('[data-pro-journey-dot]');
    if (!slides.length || slides.length <= 1) return;

    var current = 0;

    function setSlideState(idx, active) {
      slides[idx].classList.toggle('is-active', active);
      slides[idx].setAttribute('aria-hidden', active ? 'false' : 'true');
      var link = slides[idx].querySelector('.pro-journey__slide-link');
      if (link) link.setAttribute('tabindex', active ? '0' : '-1');
      if (dots[idx]) {
        dots[idx].classList.toggle('is-active', active);
        dots[idx].setAttribute('aria-selected', active ? 'true' : 'false');
      }
    }

    function go(i) {
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      if (i === current) return;
      setSlideState(current, false);
      current = i;
      setSlideState(current, true);
    }
    function next() { go(current + 1); }
    function prev() { go(current - 1); }

    Array.prototype.forEach.call(dots, function (d) {
      d.addEventListener('click', function () {
        var i = parseInt(d.getAttribute('data-target'), 10) || 0;
        go(i);
      });
    });

    var main = section.querySelector('[data-pro-journey-main]');
    if (main) {
      var startX = 0;
      var startY = 0;
      var dragging = false;
      var moved = false;
      var THRESHOLD = 40;

      main.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        dragging = true;
        moved = false;
        startX = e.clientX;
        startY = e.clientY;
        try { main.setPointerCapture(e.pointerId); } catch (_) {}
      });

      main.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        var dy = e.clientY - startY;
        if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) {
          moved = true;
          if (e.cancelable) e.preventDefault();
        }
      }, { passive: false });

      function endDrag(e) {
        if (!dragging) return;
        dragging = false;
        var dx = (e.clientX || 0) - startX;
        if (moved && Math.abs(dx) > THRESHOLD) {
          if (dx < 0) next(); else prev();
        }
        try { main.releasePointerCapture(e.pointerId); } catch (_) {}
      }

      main.addEventListener('pointerup', endDrag);
      main.addEventListener('pointercancel', function (e) {
        dragging = false;
        try { main.releasePointerCapture(e.pointerId); } catch (_) {}
      });

      main.addEventListener('click', function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      }, true);

      main.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-pro-journey]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-pro-journey]');
    if (s) init(s);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-pro-product-row"] && !Shopify.designMode) return;
  try {
    
(function () {
  var loadingButtons = [];

  function clearLoadingButtons() {
    while (loadingButtons.length) {
      var b = loadingButtons.pop();
      b.classList.remove('is-loading');
    }
  }

  function watchCartDrawer() {
    var drawer = document.querySelector('.cart_drawer');
    if (!drawer) return;
    var observer = new MutationObserver(function () {
      if (drawer.classList.contains('drawer_is_open')) clearLoadingButtons();
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pro-card__atc');
    if (!btn || btn.disabled) return;
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    loadingButtons.push(btn);
    setTimeout(function () { btn.classList.remove('is-loading'); }, 6000);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchCartDrawer);
  } else {
    watchCartDrawer();
  }

  function init(section) {
    var list = section.querySelector('[data-pro-row-list]');
    var prev = section.querySelector('[data-pro-row-prev]');
    var next = section.querySelector('[data-pro-row-next]');
    if (!list) return;

    function step() {
      var first = list.querySelector('.pro-row__item');
      if (!first) return list.clientWidth;
      var styles = window.getComputedStyle(list);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function updateNavState() {
      if (!prev || !next) return;
      var max = list.scrollWidth - list.clientWidth - 1;
      prev.disabled = list.scrollLeft <= 1;
      next.disabled = list.scrollLeft >= max;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        list.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        list.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    list.addEventListener('scroll', updateNavState, { passive: true });
    window.addEventListener('resize', updateNavState);

    updateNavState();
  }

  function initAll() {
    var sections = document.querySelectorAll('.pro-row');
    Array.prototype.forEach.call(sections, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.pro-row');
    if (s) init(s);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-pro-results"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSection(section) {
    if (section.dataset.proResultsInit === '1') return;
    section.dataset.proResultsInit = '1';

    var list = section.querySelector('[data-pro-results-list]');
    var prev = section.querySelector('[data-pro-results-prev]');
    var next = section.querySelector('[data-pro-results-next]');
    if (!list) return;

    function step() {
      var first = list.querySelector('.pro-results__item');
      if (!first) return list.clientWidth;
      var styles = window.getComputedStyle(list);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function updateNavState() {
      if (!prev || !next) return;
      var max = list.scrollWidth - list.clientWidth - 1;
      prev.disabled = list.scrollLeft <= 1;
      next.disabled = list.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () {
      list.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      list.scrollBy({ left: step(), behavior: 'smooth' });
    });

    list.addEventListener('scroll', updateNavState, { passive: true });
    window.addEventListener('resize', updateNavState);
    window.addEventListener('load', updateNavState);

    Array.prototype.forEach.call(list.querySelectorAll('img'), function (img) {
      if (img.complete) return;
      img.addEventListener('load', updateNavState, { once: true });
      img.addEventListener('error', updateNavState, { once: true });
    });

    if ('ResizeObserver' in window) {
      new ResizeObserver(updateNavState).observe(list);
    }

    requestAnimationFrame(updateNavState);
  }

  function initAll() {
    document.querySelectorAll('[data-pro-results]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-pro-results]');
    if (s) initSection(s);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-pro-shoppable-videos"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initSection(section) {
    if (section.dataset.psvInit === '1') return;
    section.dataset.psvInit = '1';

    var sectionId = section.dataset.sectionId;
    var dialog = document.getElementById('psv-dialog-' + sectionId);
    if (!dialog) return;

    var slides    = dialog.querySelector('[data-sv-slides]');
    var muteBtns  = dialog.querySelectorAll('[data-sv-mute]');
    var prevBtn   = dialog.querySelector('[data-sv-prev]');
    var nextBtn   = dialog.querySelector('[data-sv-next]');
    var closeBtns = dialog.querySelectorAll('[data-sv-close]');
    var cards     = section.querySelectorAll('[data-sv-card]');

    if (!slides) return;

    var allSlides   = Array.prototype.slice.call(slides.querySelectorAll('.psv-dialog__slide'));
    var activeIndex = 0;
    var observer    = null;

    /* ---- Helpers ---- */

    function getVideo(slide) {
      return slide ? slide.querySelector('spectrum-video') : null;
    }

    function safeCall(el, method) {
      if (el && typeof el[method] === 'function') {
        try { el[method](); } catch (e) {}
      }
    }

    function getActiveVideo() {
      return getVideo(allSlides[activeIndex]);
    }

    function isDesktop() {
      return window.innerWidth > 749;
    }

    function getCurrency() {
      try {
        if (window.Spectrum && typeof window.Spectrum.getActiveCurrency === 'function') {
          return window.Spectrum.getActiveCurrency() || 'USD';
        }
      } catch (e) {}
      return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    }

    function trackEvent(name, props) {
      try {
        if (window.__spectrumAi && window.__spectrumAi.analytics && typeof window.__spectrumAi.analytics.trackEvent === 'function') {
          window.__spectrumAi.analytics.trackEvent(name, props);
        }
      } catch (e) {}
    }

    function entityFromAtcButton(btn) {
      if (!btn) return { product: null, variant: null };
      var amount = parseInt(btn.dataset.priceAmount, 10);
      if (isNaN(amount)) amount = 0;
      var currencyCode = getCurrency();
      return {
        product: btn.dataset.productId
          ? {
              id: String(btn.dataset.productId),
              handle: btn.dataset.productHandle || '',
              title: btn.dataset.productTitle || '',
              url: btn.dataset.productUrl || '',
              price: { amount: amount, currencyCode: currencyCode },
              image: btn.dataset.productImage || ''
            }
          : null,
        variant: btn.dataset.variantId
          ? {
              id: String(btn.dataset.variantId),
              title: btn.dataset.variantTitle || '',
              price: { amount: amount, currencyCode: currencyCode },
              sku: btn.dataset.variantSku || ''
            }
          : null
      };
    }

    function trackPlay(idx) {
      var slide = allSlides[idx];
      if (!slide) return;
      var atcBtn = slide.querySelector('[data-sv-atc]');
      var entity = entityFromAtcButton(atcBtn);
      var videoUrl = atcBtn ? (atcBtn.dataset.videoUrl || '') : '';
      trackEvent('shoppable_video_play', Object.assign({}, entity, {
        videoUrl: videoUrl,
        __spectrumVariant: 'spectrum-ai'
      }));
    }

    /* ---- Mute ---- */

    function updateMuteIcons() {
      var active = getActiveVideo();
      var isMuted = active ? active.muted : true;
      if (!muteBtns || !muteBtns.length) return;
      Array.prototype.forEach.call(muteBtns, function (btn) {
        var iconMuted = btn.querySelector('.psv-icon-muted');
        var iconSound = btn.querySelector('.psv-icon-sound');
        if (isMuted) {
          if (iconMuted) iconMuted.style.display = '';
          if (iconSound) iconSound.style.display = 'none';
          btn.setAttribute('aria-label', 'Unmute video');
        } else {
          if (iconMuted) iconMuted.style.display = 'none';
          if (iconSound) iconSound.style.display = '';
          btn.setAttribute('aria-label', 'Mute video');
        }
      });
    }

    Array.prototype.forEach.call(muteBtns, function (btn) {
      btn.addEventListener('click', function () {
        var active = getActiveVideo();
        if (!active) return;
        if (active.muted) { safeCall(active, 'unmute'); }
        else { safeCall(active, 'mute'); }
        updateMuteIcons();
      });
    });

    /* ---- Desktop position-based carousel ---- */

    function updatePositions(newIdx) {
      activeIndex = newIdx;
      allSlides.forEach(function (slide, i) {
        var diff = i - newIdx;
        var pos = diff === 0 ? 'center' : diff === -1 ? 'left' : diff === 1 ? 'right' : 'hidden';
        slide.dataset.position = pos;

        var vid = getVideo(slide);
        if (!vid) return;
        if (pos === 'center') {
          safeCall(vid, 'play');
        } else if (pos === 'hidden') {
          safeCall(vid, 'unload');
        } else {
          safeCall(vid, 'pause');
        }
      });
    }

    function preloadAdjacent(idx) {
      var total = allSlides.length;
      if (total <= 1) return;
      [(idx - 1 + total) % total, (idx + 1) % total].forEach(function (i) {
        safeCall(getVideo(allSlides[i]), 'load');
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (activeIndex > 0) {
          var newIdx = activeIndex - 1;
          preloadAdjacent(newIdx);
          updatePositions(newIdx);
          updateMuteIcons();
          trackPlay(newIdx);
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (activeIndex < allSlides.length - 1) {
          var newIdx = activeIndex + 1;
          preloadAdjacent(newIdx);
          updatePositions(newIdx);
          updateMuteIcons();
          trackPlay(newIdx);
        }
      });
    }

    /* ---- Mobile observer ---- */

    function setupMobileObserver() {
      if (observer) observer.disconnect();
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var vid = getVideo(entry.target);
          if (!vid) return;
          if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
            var idx = parseInt(entry.target.dataset.slideIndex, 10) || 0;
            if (idx !== activeIndex) {
              activeIndex = idx;
              updateMuteIcons();
              trackPlay(idx);
            }
            safeCall(vid, 'play');
          } else {
            safeCall(vid, 'pause');
          }
        });
      }, { root: slides, threshold: 0.6 });
      allSlides.forEach(function (slide) { observer.observe(slide); });
    }

    /* ---- Open / Close ---- */

    function resetAtcButtons() {
      dialog.querySelectorAll('[data-sv-atc]').forEach(function (btn) {
        if (!btn.dataset.svOriginal) return;
        var label = btn.querySelector('[data-sv-atc-label]');
        if (label) label.textContent = btn.dataset.svOriginal;
        btn.disabled = false;
        btn.classList.remove('psv-dialog__atc--added');
      });
    }

    function openDialog(startIndex) {
      activeIndex = startIndex;

      if (isDesktop()) {
        slides.classList.add('psv-no-transition');
        allSlides.forEach(function (slide, i) {
          var diff = i - startIndex;
          slide.dataset.position = diff === 0 ? 'center' : diff === -1 ? 'left' : diff === 1 ? 'right' : 'hidden';
        });
      }

      dialog.showModal();
      document.body.style.overflow = 'hidden';

      requestAnimationFrame(function () {
        if (isDesktop()) {
          /* eslint-disable no-unused-expressions */
          slides.offsetHeight;
          /* eslint-enable no-unused-expressions */
          slides.classList.remove('psv-no-transition');
          preloadAdjacent(startIndex);
          updatePositions(startIndex);
        } else {
          for (var i = Math.max(0, startIndex - 1); i <= Math.min(allSlides.length - 1, startIndex + 1); i++) {
            safeCall(getVideo(allSlides[i]), 'load');
          }
          slides.scrollTop = startIndex * slides.clientHeight;
          setupMobileObserver();
          safeCall(getVideo(allSlides[startIndex]), 'play');
        }
        updateMuteIcons();
        trackPlay(startIndex);
      });
    }

    function closeDialog() {
      if (observer) { observer.disconnect(); observer = null; }
      dialog.querySelectorAll('spectrum-video').forEach(function (v) { safeCall(v, 'unload'); });
      resetAtcButtons();
      try { dialog.close(); } catch (e) {}
      document.body.style.overflow = '';
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        openDialog(parseInt(card.dataset.svIndex, 10) || 0);
      });
    });

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeDialog);
    });

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) closeDialog();
    });

    dialog.addEventListener('cancel', function () {
      if (observer) { observer.disconnect(); observer = null; }
      dialog.querySelectorAll('spectrum-video').forEach(function (v) { safeCall(v, 'unload'); });
      resetAtcButtons();
      document.body.style.overflow = '';
    });

    /* ---- Add to cart ---- */

    function attachAtcListener(btn) {
      if (!btn.dataset.svOriginal) {
        var label = btn.querySelector('[data-sv-atc-label]');
        btn.dataset.svOriginal = label ? label.textContent : 'Add to cart';
      }

      btn.addEventListener('click', function () {
        var variantId = btn.dataset.variantId;
        if (!variantId) return;

        var label = btn.querySelector('[data-sv-atc-label]');
        var Spectrum = window.Spectrum;
        if (!Spectrum || !Spectrum.cart || typeof Spectrum.cart.add !== 'function') {
          console.warn('[psv] Spectrum.cart.add unavailable');
          return;
        }

        btn.disabled = true;
        if (label) label.textContent = 'Adding...';

        Spectrum.cart.add({ id: parseInt(variantId, 10), quantity: 1 })
          .then(function (res) {
            if (res && res.ok === false) { throw new Error('Add failed'); }
            var entity = entityFromAtcButton(btn);
            trackEvent('shoppable_video_atc', Object.assign({}, entity, {
              quantity: 1,
              videoUrl: btn.dataset.videoUrl || '',
              __spectrumVariant: 'spectrum-ai'
            }));
            if (label) label.textContent = 'Added';
            btn.classList.add('psv-dialog__atc--added');

            /* THEME-SPECIFIC: Bozeman cart drawer refresh + open.
               Mirrors theme.js .grid-add-to-cart-btn handler:
               cart_drawer() refreshes markup, then drawer_is_open + stop_page_scroll. */
            closeDialog();
            try {
              if (typeof window.cart_drawer === 'function') {
                window.cart_drawer();
              }
              if (window.jQuery) {
                window.jQuery('.cart_drawer').addClass('drawer_is_open');
                window.jQuery('html body').addClass('stop_page_scroll');
              }
            } catch (e) {}
            /* END THEME-SPECIFIC */

            setTimeout(function () {
              btn.disabled = false;
              btn.classList.remove('psv-dialog__atc--added');
              if (label) label.textContent = btn.dataset.svOriginal || 'Add to cart';
            }, 1400);
          })
          .catch(function (err) {
            console.error('[psv] cart add failed', err);
            if (label) label.textContent = 'Try again';
            setTimeout(function () {
              btn.disabled = false;
              if (label) label.textContent = btn.dataset.svOriginal || 'Add to cart';
            }, 1800);
          });
      });
    }

    dialog.querySelectorAll('[data-sv-atc]').forEach(attachAtcListener);
  }

  function initAll() {
    document.querySelectorAll('[data-psv]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-psv]');
    if (s) initSection(s);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-pro-spotlight"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(section) {
    if (section.dataset.proSpotlightInit === '1') return;
    section.dataset.proSpotlightInit = '1';

    var track = section.querySelector('[data-pro-spotlight-track]');
    var slides = section.querySelectorAll('[data-pro-spotlight-slide]');
    var dots = section.querySelectorAll('[data-pro-spotlight-dot]');
    if (!track || !slides.length) return;

    function setActiveDot(idx) {
      Array.prototype.forEach.call(dots, function (d, i) {
        var active = i === idx;
        d.classList.toggle('is-active', active);
        d.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function getSnapPadding() {
      var cs = getComputedStyle(track);
      return parseFloat(cs.scrollPaddingLeft) || parseFloat(cs.paddingLeft) || 0;
    }

    function isCenterSnap() {
      var first = slides[0];
      if (!first) return false;
      return getComputedStyle(first).scrollSnapAlign === 'center';
    }

    function getCardStep() {
      if (slides.length < 2) return slides[0] ? slides[0].getBoundingClientRect().width : 0;
      return slides[1].offsetLeft - slides[0].offsetLeft;
    }

    function getMaxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    // Each dot maps to a discrete scroll position (one card-step apart).
    // Number of useful dots collapses to (slides.length) when every slide can
    // become the leftmost-visible card, and shrinks otherwise.
    function pageCount() {
      if (slides.length <= 1) return 1;
      var step = getCardStep();
      var maxScroll = getMaxScroll();
      if (step <= 0 || maxScroll <= 0) return 1;
      return Math.min(slides.length, Math.ceil(maxScroll / step) + 1);
    }

    function dotScrollLeft(i) {
      var step = getCardStep();
      var maxScroll = getMaxScroll();
      return Math.min(i * step, maxScroll);
    }

    function applyDotVisibility() {
      var n = pageCount();
      Array.prototype.forEach.call(dots, function (d, i) {
        d.style.display = i < n ? '' : 'none';
      });
    }

    function activeDotForScroll() {
      var n = pageCount();
      if (n <= 1) return 0;
      var step = getCardStep();
      var sl = track.scrollLeft;
      var idx = Math.round(sl / step);
      if (idx < 0) idx = 0;
      if (idx > n - 1) idx = n - 1;
      return idx;
    }

    function nearestSlideIndex() {
      var trackRect = track.getBoundingClientRect();
      var anchor;
      if (isCenterSnap()) {
        anchor = trackRect.left + trackRect.width / 2;
      } else {
        anchor = trackRect.left + getSnapPadding();
      }
      var bestIdx = 0;
      var bestDist = Infinity;
      Array.prototype.forEach.call(slides, function (s, i) {
        var r = s.getBoundingClientRect();
        var ref = isCenterSnap() ? r.left + r.width / 2 : r.left;
        var d = Math.abs(ref - anchor);
        if (d < bestDist) { bestDist = d; bestIdx = i; }
      });
      return bestIdx;
    }

    function scrollToIndex(i, smooth) {
      var target = slides[i];
      if (!target) return;
      var trackRect = track.getBoundingClientRect();
      var slideRect = target.getBoundingClientRect();
      var delta;
      if (isCenterSnap()) {
        delta = (slideRect.left + slideRect.width / 2) - (trackRect.left + trackRect.width / 2);
      } else {
        delta = (slideRect.left - trackRect.left) - getSnapPadding();
      }
      track.scrollTo({
        left: Math.max(0, track.scrollLeft + delta),
        behavior: smooth === false ? 'auto' : 'smooth'
      });
    }

    function setActiveSlide() {
      var idx = nearestSlideIndex();
      Array.prototype.forEach.call(slides, function (s, i) {
        s.classList.toggle('is-active', i === idx);
        if (i < idx) {
          s.style.transformOrigin = 'right center';
        } else if (i > idx) {
          s.style.transformOrigin = 'left center';
        } else {
          s.style.transformOrigin = 'center center';
        }
      });
    }

    var scrollRaf = 0;
    track.addEventListener('scroll', function () {
      if (scrollRaf) return;
      scrollRaf = requestAnimationFrame(function () {
        scrollRaf = 0;
        setActiveDot(activeDotForScroll());
        setActiveSlide();
      });
    }, { passive: true });

    Array.prototype.forEach.call(dots, function (d) {
      d.addEventListener('click', function () {
        var i = parseInt(d.getAttribute('data-target'), 10) || 0;
        var n = pageCount();
        if (i > n - 1) i = n - 1;
        track.scrollTo({ left: dotScrollLeft(i), behavior: 'smooth' });
        setActiveDot(i);
      });
    });

    applyDotVisibility();
    window.addEventListener('resize', applyDotVisibility);

    function stepTo(i) {
      var n = pageCount();
      if (i < 0) i = 0;
      if (i > n - 1) i = n - 1;
      track.scrollTo({ left: dotScrollLeft(i), behavior: 'smooth' });
      setActiveDot(i);
    }
    function nextStep() { stepTo(activeDotForScroll() + 1); }
    function prevStep() { stepTo(activeDotForScroll() - 1); }

    var startX = 0;
    var startY = 0;
    var dragging = false;
    var moved = false;
    var THRESHOLD = 40;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      if (e.button !== 0) return;
      dragging = true;
      moved = false;
      startX = e.clientX;
      startY = e.clientY;
    });

    track.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) {
        moved = true;
        if (e.cancelable) e.preventDefault();
      }
    }, { passive: false });

    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      var dx = (e.clientX || 0) - startX;
      if (moved && Math.abs(dx) > THRESHOLD) {
        if (dx < 0) nextStep(); else prevStep();
      }
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', function () { dragging = false; });
    track.addEventListener('pointerleave', function (e) { if (dragging) endDrag(e); });

    track.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }, true);

    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    setActiveDot(0);
    setActiveSlide();
  }

  function initAll() {
    document.querySelectorAll('[data-pro-spotlight]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-pro-spotlight]');
    if (s) init(s);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-pro-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSection(section) {
    if (section.dataset.proVideoInit === '1') return;
    section.dataset.proVideoInit = '1';

    var sv = section.querySelector('spectrum-video');
    var toggle = section.querySelector('[data-pro-video-toggle]');
    if (!sv || !toggle) return;

    function syncState(paused) {
      section.dataset.paused = paused ? 'true' : 'false';
      toggle.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
    }

    toggle.addEventListener('click', function () {
      var inner = sv.querySelector('video');
      var paused = inner ? inner.paused : section.dataset.paused === 'true';
      if (paused) {
        if (typeof sv.play === 'function') sv.play();
        syncState(false);
      } else {
        if (typeof sv.pause === 'function') sv.pause();
        syncState(true);
      }
    });

    sv.addEventListener('spectrum-video:play', function () { syncState(false); });
    sv.addEventListener('spectrum-video:pause', function () { syncState(true); });

    syncState(false);
  }

  function initAll() {
    document.querySelectorAll('[data-pro-video]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-pro-video]');
    if (s) initSection(s);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-row"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var scrollers = document.querySelectorAll('[data-prod-row-scroll]');
    scrollers.forEach(function (track) {
      var root = track.closest('[id^="shopify-section-"]');
      if (!root || root.dataset.prodRowInit === '1') return;
      root.dataset.prodRowInit = '1';
      var thumb = root.querySelector('[data-prod-row-thumb]');
      var next = root.querySelector('[data-prod-row-next]');
      if (!thumb) return;

      function update() {
        var total = track.scrollWidth;
        var visible = track.clientWidth;
        var maxScroll = Math.max(total - visible, 0);
        var ratio = visible / total;
        var thumbWidth = Math.max(Math.min(ratio, 1), 0.1) * 100;
        var offset = maxScroll > 0 ? (track.scrollLeft / maxScroll) * (100 - thumbWidth) : 0;
        thumb.style.width = thumbWidth + '%';
        thumb.style.left = offset + '%';
        if (next) {
          if (maxScroll <= 1) {
            next.setAttribute('disabled', '');
          } else if (track.scrollLeft >= maxScroll - 1) {
            next.setAttribute('disabled', '');
          } else {
            next.removeAttribute('disabled');
          }
        }
      }

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(update);
      });
      window.addEventListener('resize', function () {
        window.requestAnimationFrame(update);
      });

      if (next) {
        next.addEventListener('click', function () {
          var firstCard = track.querySelector('.prod-row__card');
          var step = firstCard ? firstCard.getBoundingClientRect().width + 16 : track.clientWidth * 0.6;
          track.scrollBy({ left: step, behavior: 'smooth' });
        });
      }
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-success-stories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var tracks = document.querySelectorAll('[data-success-stories-track]');
    tracks.forEach(function (track) {
      var root = track.closest('[id^="shopify-section-"]');
      if (!root || root.dataset.storiesInit === '1') return;
      root.dataset.storiesInit = '1';

      var dotsWrap = root.querySelector('[data-success-stories-dots]');
      var cards = track.querySelectorAll('.success-stories__card');
      if (!dotsWrap || cards.length === 0) return;
      var dotEls = Array.prototype.slice.call(dotsWrap.querySelectorAll('.success-stories__dot'));

      function computePageCount() {
        var total = track.scrollWidth;
        var visible = track.clientWidth;
        if (visible <= 0) return 1;
        var pages = Math.ceil((total - 1) / visible);
        return Math.max(1, Math.min(pages, dotEls.length));
      }

      function layout() {
        var pages = computePageCount();
        dotEls.forEach(function (d, i) {
          d.style.display = i < pages ? '' : 'none';
        });
        update();
        if (pages <= 1) {
          dotsWrap.style.display = 'none';
        } else {
          dotsWrap.style.display = '';
        }
      }

      function update() {
        var pages = computePageCount();
        var maxScroll = track.scrollWidth - track.clientWidth;
        var normalized = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
        if (normalized < 0) normalized = 0;
        if (normalized > 1) normalized = 1;
        var index = pages > 1 ? Math.round(normalized * (pages - 1)) : 0;
        dotEls.forEach(function (d, i) {
          d.classList.toggle('is-active', i === index);
        });
      }

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(update);
      });
      window.addEventListener('resize', function () {
        window.requestAnimationFrame(layout);
      });

      dotEls.forEach(function (dot, i) {
        dot.style.cursor = 'pointer';
        dot.setAttribute('role', 'button');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.setAttribute('tabindex', '0');
        dot.addEventListener('click', function () {
          var pages = computePageCount();
          var maxScroll = track.scrollWidth - track.clientWidth;
          var target = pages > 1 ? maxScroll * (i / (pages - 1)) : 0;
          track.scrollTo({ left: target, behavior: 'smooth' });
        });
      });

      layout();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-video-image-split"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var carousels = document.querySelectorAll('[data-vi-carousel]');
    carousels.forEach(function (root) {
      if (root.dataset.viInit === '1') return;
      root.dataset.viInit = '1';
      var track = root.querySelector('[data-vi-track]');
      var dots = root.querySelectorAll('[data-vi-dots] .vi-split__dot');
      if (!track || dots.length === 0) return;
      var slides = track.querySelectorAll('.vi-split__slide');

      function update() {
        var left = track.scrollLeft;
        var width = slides[0].getBoundingClientRect().width;
        var index = Math.round(left / width);
        if (index < 0) index = 0;
        if (index >= dots.length) index = dots.length - 1;
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === index);
        });
      }
      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(update);
      });
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          var width = slides[0].getBoundingClientRect().width;
          track.scrollTo({ left: width * i, behavior: 'smooth' });
        });
      });

      var interval = null;
      function start() {
        if (interval || slides.length < 2) return;
        interval = setInterval(function () {
          var width = slides[0].getBoundingClientRect().width;
          var nextIdx = Math.round(track.scrollLeft / width) + 1;
          if (nextIdx >= slides.length) nextIdx = 0;
          track.scrollTo({ left: width * nextIdx, behavior: 'smooth' });
        }, 4000);
      }
      function stop() { if (interval) { clearInterval(interval); interval = null; } }
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-coll-with-pro"] && !Shopify.designMode) return;
  try {
    
(function () {
  var loadingButtons = [];

  function clearLoadingButtons() {
    while (loadingButtons.length) {
      var b = loadingButtons.pop();
      b.classList.remove('is-loading');
    }
  }

  function watchCartDrawer() {
    var drawer = document.querySelector('.cart_drawer');
    if (!drawer) return;
    var observer = new MutationObserver(function () {
      if (drawer.classList.contains('drawer_is_open')) clearLoadingButtons();
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pro-card__atc');
    if (!btn || btn.disabled) return;
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    loadingButtons.push(btn);
    setTimeout(function () { btn.classList.remove('is-loading'); }, 6000);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchCartDrawer);
  } else {
    watchCartDrawer();
  }

  function init(section) {
    var list = section.querySelector('[data-pro-row-list]');
    var prev = section.querySelector('[data-pro-row-prev]');
    var next = section.querySelector('[data-pro-row-next]');
    if (!list) return;

    function step() {
      var first = list.querySelector('.pro-row__item');
      if (!first) return list.clientWidth;
      var styles = window.getComputedStyle(list);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function updateNavState() {
      if (!prev || !next) return;
      var max = list.scrollWidth - list.clientWidth - 1;
      prev.disabled = list.scrollLeft <= 1;
      next.disabled = list.scrollLeft >= max;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        list.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        list.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    list.addEventListener('scroll', updateNavState, { passive: true });
    window.addEventListener('resize', updateNavState);

    updateNavState();
  }

  function initAll() {
    var sections = document.querySelectorAll('.pro-row');
    Array.prototype.forEach.call(sections, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.pro-row');
    if (s) init(s);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-custom-header"] && !Shopify.designMode) return;
  try {
    
class RavelHeader {
  constructor() {
    this.predictiveUrl = document.body.dataset.predictiveUrl || '';

    this.initSearch();
    this.initMobile();
  }

  querySelector(selector) {
    return document.querySelector(selector);
  }

  querySelectorAll(selector) {
    return document.querySelectorAll(selector);
  }

  addEventListener(...args) {
    document.addEventListener(...args);
  }

  /* ---- Predictive search (desktop + mobile) ---- */
  initSearch() {
    this.searchPanel = this.querySelector('[data-search-panel]');
    const toggle = this.querySelector('[data-search-toggle]');

    if (toggle && this.searchPanel) {
      
      toggle.addEventListener('click', () => {

        if (window.matchMedia('(max-width: 989px)').matches) return;

        const open = this.searchPanel.hasAttribute('hidden');

        if (open) {
          this.openSearch();
        } else {
          this.closeSearch();
        }
      });
    }

    this.querySelectorAll('[data-search-input]').forEach((input) => {
      const results =
        input.closest('.rv-search__inner, .rv-msearch__inner, .rv-search__main')
          ?.querySelector('[data-search-results]') ||
        input.parentElement?.parentElement?.querySelector('[data-search-results]');

      let t = null;

      input.addEventListener('input', () => {
        clearTimeout(t);

        const q = input.value.trim();

        if (q.length < 2) {
          if (results) {
            results.hidden = true;
            results.innerHTML = '';
          }
          return;
        }

        t = setTimeout(() => this.runSearch(q, results), 220);
      });
    });
  }

  initMobile() {
    this.drawer = this.querySelector('[data-drawer]');
    this.scrim = this.querySelector('[data-drawer-scrim]');
    this.msearch = this.querySelector('[data-msearch]');
    const burgers = [...this.querySelectorAll('[data-drawer-toggle]')];

    const setDrawer = (open) => {
      if (!this.drawer) return;
      this.drawer.classList.toggle('is-open', open);
      this.drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (this.scrim) { this.scrim.hidden = false; this.scrim.classList.toggle('is-open', open); }
      burgers.forEach((b) => b.setAttribute('aria-expanded', open ? 'true' : 'false'));
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) this.setMSearch(false);
    };
    this.setDrawer = setDrawer;
    burgers.forEach((b) => b.addEventListener('click', () => setDrawer(!this.drawer.classList.contains('is-open'))));
    this.scrim?.addEventListener('click', () => setDrawer(false));

    // mobile search toggle reuses the same toggle button on small screens
    const setMSearch = (open) => {
      if (!this.msearch) return;
      this.msearch.hidden = !open;
      const t = this.querySelector('[data-search-mob-toggle]');
      if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { setDrawer(false); this.msearch.querySelector('[data-search-input]')?.focus(); }
    };
    this.setMSearch = setMSearch;
    const toggle = this.querySelector('[data-search-mob-toggle]');
    toggle?.addEventListener('click', () => {
      if (window.matchMedia('(max-width: 989px)').matches) {
        setMSearch(this.msearch.hidden);
      }
    });
    this.addEventListener('keydown', (e) => { if (e.key === 'Escape') { setDrawer(false); setMSearch(false); } });
  }

  openSearch() {
    const t = this.querySelector('[data-search-toggle]');

    this.querySelectorAll('[data-mega-item]').forEach((it) => {
      it.classList.remove('is-open');
    });

    if (this.searchPanel) this.searchPanel.hidden = false;

    if (t) t.setAttribute('aria-expanded', 'true');

    this.searchPanel?.querySelector('[data-search-input]')?.focus();
  }

  closeSearch() {
    const t = this.querySelector('[data-search-toggle]');

    if (this.searchPanel) this.searchPanel.hidden = true;

    if (t) t.setAttribute('aria-expanded', 'false');
  }

  async runSearch(q, results) {
    if (!results || !this.predictiveUrl) return;

    try {
      const url =
        `${this.predictiveUrl}?q=${encodeURIComponent(q)}` +
        '&resources[type]=product,collection,query' +
        '&resources[limit]=6';

      const res = await fetch(url);
      const data = await res.json();

      const products =
        (data.resources &&
          data.resources.results &&
          data.resources.results.products) ||
        [];

      results.hidden = false;

      if (!products.length) {
        results.innerHTML =
          `<div class="rv-sres__empty">
            No matches for "${q}". Press Enter to search everything.
          </div>`;
        return;
      }

      results.innerHTML = products
        .map((p) => {
          const img =
            p.featured_image?.url ||
            p.image ||
            '';

          return `
            <a class="rv-sres" href="${p.url}">
              <span class="rv-sres__img">
                ${img ? `<img src="${img}" alt="${p.title}" loading="lazy">` : ''}
              </span>
              <span class="rv-sres__body">
                <div class="rv-sres__name">${p.title}</div>
              </span>
            </a>
          `;
        })
        .join('');
    } catch (e) {
      results.hidden = true;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new RavelHeader();
});


document.addEventListener('DOMContentLoaded', function () {
  const items = document.querySelectorAll('.custom_announcementbar2 > span');

  let current = 0;

  // Start ma badha hide karo
  items.forEach((item, index) => {
    item.style.display = index === 0 ? 'inline-flex' : 'none';
  });

  setInterval(() => {
    items[current].style.display = 'none';

    current = (current + 1) % items.length;

    items[current].style.display = 'inline-flex';
  }, 5000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ravel-pro-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(scope) {
    // Sort: navigate with sort_by, drop the page param.
    scope.querySelectorAll('[data-rpc-sort]').forEach(function (sel) {
      if (sel.dataset.rpcBound) return;
      sel.dataset.rpcBound = '1';
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
    // Center the active tab in its scroll rail.
    scope.querySelectorAll('.rpc-tabs__rail').forEach(function (rail) {
      var active = rail.querySelector('[data-active="true"]');
      if (active) {
        rail.scrollTo({ left: active.offsetLeft - rail.clientWidth / 2 + active.clientWidth / 2 });
      }
    });
  }
  init(document);
  // Re-bind when re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) init(e.target);
  });

  // ── Add to cart → open the theme cart drawer (no page reload) ──────────────
  // Opens whatever the store uses site-wide: the .js_cart_drwer_show / #cartDrawer
  // trigger seen in the header. Falls back to the /cart page if no drawer exists.
  function openCartDrawer() {
    var trigger = document.querySelector('.js_cart_drwer_show, [href="#cartDrawer"], [data-cart-drawer-open]');
    if (trigger) { trigger.click(); return true; }
    return false;
  }

  // Delegated once on document — survives theme-editor re-renders and pagination.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('.rpc-card__form');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('.rpc-card__btn');
    if (btn && btn.getAttribute('aria-busy') === 'true') return;
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.style.opacity = '0.7'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { throw new Error((res.data && res.data.description) || 'add-failed'); }
        // Let themes that listen for cart events refresh their drawer/count.
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
        if (!openCartDrawer()) { window.location.href = '/cart'; }
      })
      .catch(function () { window.location.href = '/cart'; })
      .finally(function () {
        if (btn) { btn.removeAttribute('aria-busy'); btn.style.opacity = ''; }
      });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
